import { ReactNode } from "react";

const sections = [
  {
    title: "Instant 12-person Sales Team",
    imgUrl: "/sales-team.png",
  },
  {
    title: "Multi-media & Marketing Assets",
    imgUrl: "/multi-media.png",
  },
  {
    title: "Sales Channels",
    imgUrl: "/sales-channels.png",
  },
  {
    title: "Tool Stack",
    imgUrl: "/tool-stack.png",
  },
];
const Included = () => {
  return (
    <div>
      <p className="text-black text-center lg:mt-16 lg:mb-10 my-5 font-bold text-2xl lg:text-[2.5rem]">
        Everything below is included!
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
        {sections.map((sec, index) => {
          return (
            <GrayBox key={index}>
              <p className="font-bold text-center lg:mb-10 text-[2rem]">{sec.title}</p>
              <img src={sec.imgUrl} />
            </GrayBox>
          );
        })}
        <div className=" mt-2 lg:col-span-2">
          <GrayBox>
            <p className="font-bold mb-4 text-[2rem]">Data Platforms</p>
            <img src="/data-platforms.png" />
          </GrayBox>
        </div>
      </div>
    </div>
  );
};

function GrayBox({ children }: { children: ReactNode }) {
  return (
    <div className=" flex flex-col items-center py-10 px-6 lg:px-0 bg-[#F6F6F6]">
      {children}
    </div>
  );
}

export default Included;
